var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.57602 0.368011H43.424C44.666 0.368011 45.678 1.61001 45.678 2.62201V43.286C45.678 44.528 44.666 45.54 43.424 45.54H2.57602C1.33402 45.54 0.322021 44.298 0.322021 43.286V2.62201C0.322021 1.38001 1.33402 0.368011 2.57602 0.368011Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.652 10.304V11.224H15.732C14.214 11.224 13.018 12.42 13.018 13.938V32.936C13.018 34.454 14.214 35.65 15.732 35.65H30.222C31.74 35.65 32.936 34.454 32.936 32.936V13.938C32.936 12.42 31.74 11.224 30.222 11.224H29.302V10.304H27.508V11.224H26.588V10.304H24.794V11.224H23.874V10.304H22.08V11.224H21.16V10.304H19.366V11.224H18.446V10.304H16.652ZM29.348 26.634H16.652V24.84H29.348V26.634ZM29.348 23H16.652V21.206H29.348V23ZM29.348 17.572V19.366H16.652V17.572H29.348Z",
    fill: "url(#paint0_linear_106_12343)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.348 24.794H16.652V26.588H29.348V24.794Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.806 28.474L24.656 31.464L27.646 30.314L25.806 28.474Z",
    fill: "#EAE3ED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.456 17.618C38.18 17.342 37.812 17.204 37.398 17.204C36.984 17.204 36.616 17.342 36.34 17.618L33.166 20.792L26.22 27.784L28.29 29.854L38.456 19.734C39.054 19.136 39.054 18.216 38.456 17.618Z",
    fill: "#591E71"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.348 10.304H16.652V11.224H29.348V10.304Z",
    fill: "#591E71"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.348 17.572H16.652V19.366H29.348V17.572Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.348 21.206H16.652V23H29.348V21.206Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_106_12343",
    x1: 13.018,
    y1: 22.977,
    x2: 32.936,
    y2: 22.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 4.79233e-9,
    stopColor: "#FC8162"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF406F"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPage);
export default __webpack_public_path__ + "static/media/page.27491ac0d0a217993a79c82288d16b02.svg";
export { ForwardRef as ReactComponent };